import UICnProgress from './progress';
import './styles/index.scss';
const CnProgress = UICnProgress;
CnProgress.displayName = 'CnProgress';
export { CnProgress };
